export const theme = {
  primary: '#F97316',
  primaryDark: '#EA580C',
  primaryLight: '#FED7AA',
  dark: '#1C1C1C',
  darkSecondary: '#2D2D2D',
  gray: '#4B5563',
  lightBg: '#FFF7ED',
  pageBg: '#F9FAFB',
  white: '#FFFFFF',
  border: '#E5E7EB',
  text: '#1F2937',
  textMuted: '#6B7280',
  success: '#10B981',
  warning: '#F59E0B',
  danger: '#EF4444',
  info: '#3B82F6',
  cardBg: '#FFFFFF',
  sidebarBg: '#1C1C1C',
  sidebarText: '#D1D5DB',
  sidebarActive: '#F97316',
};

export default theme;
